import React, { memo } from 'react';
import { useQuery } from '@apollo/client';
import {
  FetchOrgDetailsForPpcQuery,
  FetchOrgDetailsForPpcQueryVariables,
  ProvisionedResourceMetadataObject,
  Maybe,
  SortDirection,
} from '@css-xp/graphtypes/src/generated-types-new';
import { DEFAULT_PAGE_SIZE } from '@css-xp/ppc-constants';
import { usePersistedCacheQuery } from '@css-xp/ppc-custom-hooks';
import { fetchOrganisations } from './queries/fetch-organisation-search';
import { OrganisationTable } from '@css-xp/ppc-organisation-table';

interface OrganisationSearchProps {
  searchTerm: string;
  transactionAccountId: string;
}
const TOTAL_COUNT = 0;

export const OrganisationSearch = memo(({ searchTerm, transactionAccountId }: OrganisationSearchProps) => {
  const defaultFilterOptions = {
    and: [
      {
        key: 'orgName',
        value: searchTerm,
      },
    ],
  };
  const queryVarsForOrganisationTab = {
    filterOptions: defaultFilterOptions,
    searchOptions: {
      first: DEFAULT_PAGE_SIZE,
      offset: 0,
      sort: {
        sortFields: ['id'],
        sortFieldsDirections: [SortDirection.DESC],
      },
    },
    transactionAccountId: transactionAccountId,
  };

  const { error, loading, data, refetch } = usePersistedCacheQuery<
    FetchOrgDetailsForPpcQuery,
    FetchOrgDetailsForPpcQueryVariables
  >(fetchOrganisations, {
    variables: queryVarsForOrganisationTab,
    displayName: 'fetchOrganisations',
    fetchPolicy: 'cache-and-network',
  });

  const dataState = {
    loading: loading,
    error: error?.toString(),
    data: data?.fetchOrganisations?.nodes || [],
    refetch: refetch,
    totalCount: data?.fetchOrganisations?.totalCount ?? TOTAL_COUNT,
  };

  return (
    <div data-testid="organsiation-search">
      {
        <OrganisationTable
          dataState={dataState}
          transactionAccountId={transactionAccountId}
          label={'Organisation'}
          defaultFilterOptions={defaultFilterOptions}
        />
      }
    </div>
  );
});
